import api from './axios';

export const backupLogAPI = {
  getAllLogs: async (page = 1, limit = 20, status = '') => {
    const response = await api.get('/backup-logs', {
      params: { page, limit, status },
    });
    return response.data;
  },

  getLogsByConfig: async (configId, page = 1, limit = 20, status = '') => {
    const response = await api.get(`/backup-config/${configId}/logs`, {
      params: { page, limit, status },
    });
    return response.data;
  },

  getLogsByInstallation: async (uniqueId, page = 1, limit = 20, status = '') => {
    const response = await api.get(`/installation/${uniqueId}/logs`, {
      params: { page, limit, status },
    });
    return response.data;
  },

  getLogById: async (logId) => {
    const response = await api.get(`/backup-log/${logId}`);
    return response.data;
  },

  getStatistics: async (uniqueId, days = 7) => {
    const response = await api.get(`/installation/${uniqueId}/backup-statistics`, {
      params: { days },
    });
    return response.data;
  },

  getRunningBackups: async () => {
    const response = await api.get('/backup-logs/running');
    return response.data;
  },

  cleanupOldLogs: async (days = 90) => {
    const response = await api.delete('/backup-logs/cleanup', {
      params: { days },
    });
    return response.data;
  },
};